export const sanitizeThemeStyleByNumber = inputWidthProp =>
  !Number.isNaN(Number(inputWidthProp))
    ? `${inputWidthProp}px`
    : inputWidthProp;

export const getSeparatedStyleValueArr = valStr =>
  valStr.split(' ').map(val => Number(val.replace('px', '')));

export const getActionButtonWidth = (
  widthProp,
  widthStyleProp,
  isVerticalLayout,
  isButtonHidden,
) => {
  const parsedWidth = parseInt(widthProp, 10);
  const isButtonWidthNotSet = !isButtonHidden
    ? Number.isNaN(parsedWidth) || parsedWidth === 0
    : true;
  const isAddFullWidthClass = true;

  if (isButtonWidthNotSet) {
    if (isVerticalLayout) {
      return ['auto', !isAddFullWidthClass, isButtonWidthNotSet];
    }
    if (widthStyleProp === 'fitContent') {
      return ['calc(50% - 4px)', !isAddFullWidthClass, isButtonWidthNotSet];
    }
    if (widthStyleProp === 'fullWidth') {
      return ['100%', isAddFullWidthClass, isButtonWidthNotSet];
    }
  }

  return [widthProp, !isAddFullWidthClass, isButtonWidthNotSet];
};

export const getCommonButtonWidthStyle = (...widthStyles) => {
  if (widthStyles.some(style => style === 'fullWidth')) {
    return 'fullWidth';
  }

  return 'fitContent';
};

export const getFourSideStringFormat = (value = '') => {
  if (value.split(' ').length === 1) {
    return `${value}px ${value}px ${value}px ${value}px`;
  }

  return value;
};

export const getDiscountCodeStyleFromTheme = theme => ({
  // widget styles
  discountCodeWidgetBackgroundColor: theme.discoundCodeWidgetBackgroundColor,
  discountCodeWidgetPadding: theme.discountCodeWidgetPadding,
  discountCodeWidgetMargin: theme.discountCodeWidgetMargin,

  // input styles
  discountCodeInputPlaceholder: theme.discountCodeInputPlaceholder,
  discountCodeInputBackgroundColor: theme.discoundCodeInputBackgroundColor,
  discountCodeInputBorderColor: theme.discoundCodeInputBorderColor,
  discountCodeInputBorderRadius: theme.discountCodeInputBorderRadius,
  discountCodeInputPadding: theme.discountCodeInputPadding,
  discountCodeInputMargin: theme.discountCodeInputMargin,
  discountCodeInputFontSize: theme.discountCodeButtonFontSize,
  discountCodeInputMobileFontSize: theme.discountCodeButtonMobileFontSize,

  // Apply button styles
  discountCodeDefaultButtonColor: theme.discountCodeDefaultButtonColor,
  discountCodeButtonText: theme.discountCodeButtonText,
  discountCodeButtonColor: theme.discountCodeButtonColor,
  discountCodeButtonFontSize: theme.discountCodeButtonFontSize,
  discountCodeButtonMobileFontSize: theme.discountCodeButtonMobileFontSize,
  discountCodeButtonTextColor: theme.discountCodeButtonTextColor,
  discountCodeButtonFontStyle: theme.discountCodeButtonFontStyle,
  discountCodeButtonTextDecoration: theme.discountCodeButtonTextDecoration,
  discountCodeButtonFontWeight: theme.discountCodeButtonFontWeight,
  discountCodeButtonBorderRadius: theme.discountCodeButtonBorderRadius,
  discountCodeButtonStyle: theme.discountCodeButtonStyle,
  discountCodeButtonFontFamily: theme.discountCodeButtonFontFamily,
  discountCodeButtonTextAlignment: theme.discountCodeButtonTextAlignment,
  discountCodeButtonPadding: theme.discountCodeButtonPadding,
  discountCodeButtonMargin: theme.discountCodeButtonMargin,
  discountCodeButtonWidth: theme.discountCodeButtonWidth,
  discountCodeButtonHeight: theme.discountCodeButtonHeight,

  // Discount code chip styles
  discountCodeChipBackgroundColor: theme.discountCodeChipBackgroundColor,
  discountCodeChipBorderRadius: theme.discountCodeChipBorderRadius,
  discountCodeChipFontSize: theme.discountCodeChipFontSize,
  discountCodeChipTextColor: theme.discountCodeChipTextColor,
  discountCodeChipPadding: theme.discountCodeChipPadding,
  discountCodeChipMargin: theme.discountCodeChipMargin,

  // Discount code input toggle text styles
  discountCodeEnabledText: theme.discountCodeEnabledText,
  discountCodeEnabledTextColor: theme.discountCodeEnabledTextColor,
  discountCodeEnabledFontSize: theme.discountCodeEnabledFontSize,
  discountCodeEnabledMobileFontSize: theme.discountCodeEnabledMobileFontSize,
  discountCodeEnabledFontStyle: theme.discountCodeEnabledFontStyle,
  discountCodeEnabledFontWeight: theme.discountCodeEnabledFontWeight,
  discountCodeEnabledTextDecoration: theme.discountCodeEnabledTextDecoration,
  discountCodeEnabledTextAlignment: theme.discountCodeEnabledTextAlignment,
  discountCodeEnabledFontFamily: theme.discountCodeEnabledFontFamily,
  discountCodeEnabledPadding: theme.discountCodeEnabledPadding,
  discountCodeEnabledMargin: theme.discountCodeEnabledMargin,

  // applid info text
  discountCodeAppliedInfoText: theme.discountCodeAppliedInfoText,
  fsDiscountCodeAppliedInfoText: theme.fsDiscountCodeAppliedInfoText,
  discountCodeAppliedInfoTextColor: theme.discountCodeAppliedInfoTextColor,
  discountCodeAppliedInfoFontSize: theme.discountCodeAppliedInfoFontSize,
  discountCodeAppliedInfoMobileFontSize:
    theme.discountCodeAppliedInfoMobileFontSize,
  discountCodeAppliedInfoFontStyle: theme.discountCodeAppliedInfoFontStyle,
  discountCodeAppliedInfoFontWeight: theme.discountCodeAppliedInfoFontWeight,
  discountCodeAppliedInfoTextDecoration:
    theme.discountCodeAppliedInfoTextDecoration,
  discountCodeAppliedInfoTextAlignment:
    theme.discountCodeAppliedInfoTextAlignment,
  discountCodeAppliedInfoFontFamily: theme.discountCodeAppliedInfoFontFamily,
  discountCodeAppliedInfoPadding: theme.discountCodeAppliedInfoPadding,
  discountCodeAppliedInfoMargin: theme.discountCodeAppliedInfoMargin,

  // error text styles
  discountCodeInvalidText: theme.discountCodeInvalidText,
  discountCodeCombineErrorText: theme.discountCodeCombineErrorText,
  discountCodeInvalidTextColor: theme.discountCodeInvalidTextColor,
  discountCodeInvalidFontSize: theme.discountCodeInvalidFontSize,
  discountCodeInvalidMobileFontSize: theme.discountCodeInvalidMobileFontSize,
  discountCodeInvalidFontStyle: theme.discountCodeInvalidFontStyle,
  discountCodeInvalidFontWeight: theme.discountCodeInvalidFontWeight,
  discountCodeInvalidTextDecoration: theme.discountCodeInvalidTextDecoration,
  discountCodeInvalidTextAlignment: theme.discountCodeInvalidTextAlignment,
  discountCodeInvalidFontFamily: theme.discountCodeInvalidFontFamily,
  discountCodeInvalidPadding: theme.discountCodeInvalidPadding,
  discountCodeInvalidMargin: theme.discountCodeInvalidMargin,
});

export const getProductButtonStyleAndTextColorValue = ({
  theme,
  isEmbedded,
  isBundleOffer,
}) => {
  const {
    embeddedProductButtonStyle,
    embeddedProductButtonTextColor,
    fullpageProductButtonStyle,
    fullpageProductButtonTextColor,
    productButtonStyle,
    productButtonTextColor,
    popupDesktopLayoutType,
    popupMobileLayoutType,
  } = theme;

  if (isEmbedded) {
    return {
      styleValue: embeddedProductButtonStyle,
      textColorValue: embeddedProductButtonTextColor,
    };
  }

  if (isBundleOffer) {
    return {
      styleValue: productButtonStyle,
      textColorValue: productButtonTextColor,
    };
  }

  if (
    popupMobileLayoutType === 'fullpage' ||
    popupDesktopLayoutType === 'fullpage'
  ) {
    return {
      styleValue: fullpageProductButtonStyle,
      textColorValue: fullpageProductButtonTextColor,
    };
  }

  return {
    styleValue: productButtonStyle,
    textColorValue: productButtonTextColor,
  };
};
